import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";

export function makePlatformBrandingSchema(t: TFunction): Schema {
  return {
    // Тема - палитра
    "theme.palette.type": {
      type: "select",
      label: t("platformBranding.form.paletteTypeLabel"),
      options: [
        { value: "light", label: t("platformBranding.paletteType.light") },
        { value: "dark", label: t("platformBranding.paletteType.dark") },
      ],
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    "theme.palette.primary": {
      type: "color",
      label: t("platformBranding.form.primaryColorLabel"),
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    "theme.palette.secondary": {
      type: "color",
      label: t("platformBranding.form.secondaryColorLabel"),
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    "theme.palette.backgroundColor": {
      type: "color",
      label: t("platformBranding.form.backgroundColorLabel"),
      xs: 12,
      sm: 6,
      fullWidth: true,
    },

    // Типографика
    "theme.typography.fontFamily": {
      type: "text",
      label: t("platformBranding.form.fontFamilyLabel"),
      helperText: t("platformBranding.form.fontFamilyHelper"),
      xs: 12,
      fullWidth: true,
    },

    // Логотипы
    logoId: {
      type: "image",
      label: t("platformBranding.form.logoLabel"),
      imageType: "avatar",
      helperText: t("platformBranding.form.imageSizeHelper"),
      xs: 12,
      lg: 4,
      fullWidth: true,
    },
    faviconId: {
      type: "image",
      label: t("platformBranding.form.faviconLabel"),
      imageType: "avatar",
      helperText: t("platformBranding.form.imageSizeHelper"),
      xs: 12,
      lg: 4,
      fullWidth: true,
    },
    iconId: {
      type: "image",
      label: t("platformBranding.form.iconLabel"),
      imageType: "avatar",
      helperText: t("platformBranding.form.iconSizeHelper"),
      xs: 12,
      lg: 4,
      fullWidth: true,
    },

    // Настройки
    hideableHeader: {
      label: t("platformBranding.form.hideableHeaderLabel"),
      type: "switch",
      xs: 12,
      fullWidth: true,
    },
    isLikesEnabled: {
      label: t("platformBranding.form.isLikesEnabledLabel"),
      helperText: t("platformBranding.form.isLikesEnabledHelperText"),
      type: "switch",
      xs: 12,
      fullWidth: true,
    },
    isFavoritesEnabled: {
      label: t("platformBranding.form.isFavoritesEnabledLabel"),
      helperText: t("platformBranding.form.isFavoritesEnabledHelperText"),
      type: "switch",
      xs: 12,
      fullWidth: true,
    },
    isFeaturedVideosEnabled: {
      label: t("platformBranding.form.isFeaturedVideosEnabledLabel"),
      helperText: t("platformBranding.form.isFeaturedVideosEnabledHelperText"),
      type: "switch",
      xs: 12,
      fullWidth: true,
    },
    defaultRowSize: {
      label: t("platformBranding.form.defaultRowSizeLabel"),
      type: "select",
      xs: 12,
      sm: 6,
      fullWidth: true,
      helperText: t("platformBranding.form.defaultRowSizeHelper"),
      // Значения — числа рядов, не текст, перевода не требуют.
      options: [
        { label: "2", value: 2 },
        { label: "3", value: 3 },
        { label: "4", value: 4 },
        { label: "6", value: 6 },
      ],
    },
  };
}
